<script>
import { createMetaMixin } from 'quasar'

export default {
  inject: {
    client: { from: 'clientStore' },
    router: { from: 'routerStore' },
    accounts: { from: 'accountsStore' }
  },

  mixins: [
    createMetaMixin(function () {
      const { reCaptcha, isRecaptchaRequired } = this
      return {
        // Scripts
        script: {
          // Add Google reCaptcha library on login page
          ...(isRecaptchaRequired
            ? { reCaptcha: { src: `${reCaptcha.script}?render=${reCaptcha.key}`, type: 'text/javascript' } }
            : {}
          )
        },

        // Output current route name as body attribute
        bodyAttr: {
          'route': `artup-${this.router.currentRoute?.name}`,
          ...(this.showReCaptchaBadge ? { 'show-recaptcha': 'yes' } : {})
        }
      }
    })
  ],

  computed: {
    // Active session, if any
    session () {
      return this.accounts.session
    },

    // Running standalone, in its own browser window, so the minimal decorations
    // have to be rendered by the applet itself. When embedded in the ARTup Platform
    // wrapper, the wrapper takes care of the header, menus and footers
    isStandalone () {
      return this.client.isStandaloneApplication
    },

    // Google reCaptcha configuration
    reCaptcha () {
      return this.client.configuration?.security.login.reCaptcha || {}
    },

    // Returns true if reCaptcha is required on the current route
    isRecaptchaRequired () {
      const { reCaptcha, router } = this
      return reCaptcha.enabled && router.currentRoute?.meta.reCaptcha
    },

    // Returns true if reCaptcha badge should be visible to the user on login page
    showReCaptchaBadge () {
      const { reCaptcha } = this
      return reCaptcha.showBadge
    },
  },

  /**
   * Triggered when applet has been inserted into the page
   * Notifies the host application that the applet is ready.
   */
  created () {
    const event = new CustomEvent('applet-accounts-ready', {
      detail: { application: this }
    })
    window.dispatchEvent(event)
  }
}

</script>

<template>
  <div class="applet applet-accounts">
    <artup-applet-header v-if="isStandalone" title="Accounts" :session="session" @logout="accounts.endSession()">
    </artup-applet-header>
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss">
/*
  The applet fills the entire space made available by its host element,
  and it is the host who decides how big the applet is, whether it has borders etc.
  Views inside grow with `flex: 1` and scroll on their own when they don't fit.
*/
.applet {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
</style>
